import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { ProductContext } from "../context/AppContext";
import { autoBatchEnhancer } from "@reduxjs/toolkit";

const AdmissionForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { getRegistration, Automationdata } =
    useContext(ProductContext);

  return (
    <div class="page-container">
      <>
        <meta charSet="UTF-8" />
        <title />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n        body {\n            background-color: #444;\n            padding: 0 10px;\n            margin: 0;\n            min-width: fit-content;\n        }\n        .page-container {\n            margin: 10px auto;\n            width: fit-content;\n        }\n        .page {\n            overflow: hidden;\n            position: relative;\n            background-color: white;\n        }\n        .annotations-container {\n            position: absolute;\n            pointer-events: none;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            z-index: 3;\n        }\n        .annotations-container > div {\n            position: absolute; pointer-events: auto; -webkit-user-select: none;\n        }\n        .annotations-container > div:hover {\n            background-color: rgba(255, 255, 0, 0.25);\n            cursor: pointer;\n        }\n    ",
          }}
        />
        <style
          className="shared-css"
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n.t {\n\ttransform-origin: bottom left;\n\tz-index: 2;\n\tposition: absolute;\n\twhite-space: pre;\n\toverflow: visible;\n\tline-height: 1.5;\n}\n.text-container {\n\twhite-space: pre;\n}\n@supports (-webkit-touch-callout: none) {\n\t.text-container {\n\t\twhite-space: normal;\n\t}\n}\n",
          }}
        />
        <style
          id="fonts4"
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '\n\n@font-face {\n\tfont-family: Arial-BoldMT_s;\nsrc: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");\n}\n\n@font-face {\n\tfont-family: Arial-ItalicMT_d;\nsrc: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");\n}\n\n@font-face {\n\tfont-family: ArialMT_i;\nsrc: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");\n}\n\n@font-face {\n\tfont-family: Lohit-Devanagari_n;\nsrc: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");\n}\n\n@font-face {\n\tfont-family: Lohit-Devanagari_n_1;\nsrc: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");\n}\n\n',
          }}
        />
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\n.s0{font-size:15px;font-family:ArialMT_i;color:#333;}\n.s1{font-size:15px;font-family:Lohit-Devanagari_n;color:#333;}\n.s2{font-size:15px;font-family:Arial-BoldMT_s;color:#333;}\n.s3{font-size:13px;font-family:ArialMT_i;color:#333;}\n.s4{font-size:15px;font-family:Arial-ItalicMT_d;color:#333;}\n.s5{font-size:17px;font-family:ArialMT_i;color:#333;}\n.s6{font-size:17px;font-family:Arial-BoldMT_s;color:#333;}\n.s7{font-size:17px;font-family:Lohit-Devanagari_n;color:#333;}\n.s8{font-size:13px;font-family:Lohit-Devanagari_n;color:#333;}\n.s9{font-size:13px;font-family:Lohit-Devanagari_n_1;color:#333;}\n.sa{font-size:15px;font-family:Lohit-Devanagari_n_1;color:#333;}\n",
          }}
        />
        <div className="page-container">
          <section
            className="page"
            style={{ width: 960, height: 1286 }}
            aria-label="Page 1"
          >
            <div
              id="pg1Overlay"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 1,
                backgroundColor: "rgba(0,0,0,0)",
                WebkitUserSelect: "none",
              }}
            />
            <div
              style={{
                background: "#fff",
                width: "100%",
                height: "170px",
                zindex: "11111111111111111111",
                position: "absolute",
                top: "0px",
              }}
            >
              <div
                id="pg1"
                style={{
                  WebkitUserSelect: "none",
                  textAlign: "center",
                  alignContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  width: "100%",
                }}
              >
                <img
                  id="pdf1"
                  style={{
                    width: 180,
                    height: 180,
                    textAlign: "center",
                    alignContent: "center",
                    alignItems: "center",
                    alignSelf: "center",
                  }}
                  src={Automationdata?.data?.[0]?.schoolLogo}
                />
              </div>
            </div>
            {/* <div id="pg1" style={{ WebkitUserSelect: "none" }}> */}
              <img
                id="pdf1"
                style={{ width: 960, height: 1286 }}
                src="data:image/svg+xml,%3Csvg viewBox='0 0 960 1286' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%0A%3Cdefs%3E%0A%3CclipPath id='c0'%3E%3Cpath d='M8.8 1286.7V4.3h891V1286.7Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c1'%3E%3Cpath d='M80.4 25.1V23.5h94.1v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c2'%3E%3Cpath d='M105.1 611.9v-1.6h99.7v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c3'%3E%3Cpath d='M310.5 611.9v-1.6h91.4v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c4'%3E%3Cpath d='M639.7 611.9v-1.6h47.4v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c5'%3E%3Cpath d='M793.7 611.9v-1.6H886v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c6'%3E%3Cpath d='M357.3 652.2v-1.5H886v1.5Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c7'%3E%3Cpath d='M336.2 923.6v-1.5H886v1.5Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c8'%3E%3Cpath d='M372.9 975v-1.6H886V975Z'/%3E%3C/clipPath%3E%0A%3Cstyle%3E%0A.g0%7Bfill:%23FFF%3B%7D%0A.g1%7Bfill:%23C3C3C3%3B%7D%0A.g2%7Bfill:%232196F3%3B%7D%0A.g3%7Bfill:%23DDD%3B%7D%0A.g4%7Bfill:%23333%3B%7D%0A.g5%7Bfill:none%3Bstroke:%23333%3Bstroke-width:0.916%3Bstroke-linejoin:bevel%3Bstroke-dasharray:1%2C1%3B%7D%0A.g6%7Bfill:%23FFF%3Bstroke:%23000%3Bstroke-width:0.641%3Bstroke-linecap:square%3Bstroke-linejoin:bevel%3B%7D%0A%3C/style%3E%0A%3C/defs%3E%0A%3Cpath clip-path='url(%23c0)' d='M9.2 4.6H899.5V1286.4H9.2V4.6Z' class='g0'/%3E%0A%3Cpath d='M149.5 199.9H759.2v26.6H149.5V199.9Z' class='g1'/%3E%0A%3Cpath d='M51.3 324.6H262.2v.9H51.3v-.9Z' class='g2'/%3E%0A%3Cpath d='M51.3 529.1H262.2v.9H51.3v-.9Z' class='g2'/%3E%0A%3Cpath d='M51.3 324.6h1V530h-1V324.6Z' class='g2'/%3E%0A%3Cpath d='M261.3 324.6h.9V530h-.9V324.6Z' class='g2'/%3E%0A%3Cpath d='M348.4 324.6H559.3v.9H348.4v-.9Z' class='g2'/%3E%0A%3Cpath d='M348.4 529.1H559.3v.9H348.4v-.9Z' class='g2'/%3E%0A%3Cpath d='M348.4 324.6h.9V530h-.9V324.6Z' class='g2'/%3E%0A%3Cpath d='M558.4 324.6h.9V530h-.9V324.6Z' class='g2'/%3E%0A%3Cpath d='M645.5 324.6H856.4v.9H645.5v-.9Z' class='g2'/%3E%0A%3Cpath d='M645.5 529.1H856.4v.9H645.5v-.9Z' class='g2'/%3E%0A%3Cpath d='M645.5 324.6h.9V530h-.9V324.6Z' class='g2'/%3E%0A%3Cpath d='M855.5 324.6h.9V530h-.9V324.6Z' class='g2'/%3E%0A%3Cpath d='M9.2 316.3H305.3v.9H9.2v-.9Z' class='g3'/%3E%0A%3Cpath d='M305.3 316.3H602.4v.9H305.3v-.9Z' class='g3'/%3E%0A%3Cpath d='M602.4 316.3H899.5v.9H602.4v-.9Z' class='g3'/%3E%0A%3Cg clip-path='url(%23c1)'%3E%0A%3Cpath d='M80.7 23.8h.9v1h-.9v-1Z' class='g4'/%3E%0A%3Cpath d='M81.6 24.3h110' class='g5'/%3E%0A%3C/g%3E%0A%3Cimage clip-path='url(%23c0)' preserveAspectRatio='none' x='363' y='8' width='183' height='184' href='data:image/jpeg%3Bbase64%2C/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx4BBQUFBwYHDggIDh4UERQeHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHv/AABEIALgAtwMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5%2BgEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4%2BTl5ufo6ery8/T19vf4%2Bfr/2gAMAwEAAhEDEQA/APsqgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoASgAzQAUALQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIelGvQL2G7gTtzU3sPzHDFO92LcWmAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQA3cMZqZSUdx2ILu6ihgZ3JGOK5cdjaeCpe0mKknVukZGmXN3Pq37wFIxFkx%2BmTxn3r5nA1MbVzKUJWsrfiro7q8I06Sfc3UORX2Ltc4Emtx9MYUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBG7KASxAA65rOcoxi5Seg9bHN6hfwrDNqt45Wyt8mFc/6w%2BtfJTxUcRVlia/8ABhovNrr21T8jupw5nGnTWsg8M30l9PDeyRrELy33qo7YJwPyNGX1msd7V71tv%2B3FYnFUpRXI/s/8A6VMZ/CvrKfu6dTjvdD61EFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAY%2BsO00iacvHm/fYHnb3r5vOKkqlSng4u19W/K%2Bq%2BdzoowvCU30POviBq32%2B/XS4Plt7U7OOjsOpr4riHHxnUjgaOkYKz87XX9M%2BpyXBqNL28t3t5HTeDZhc%2BEbWaM/vrEspHc9c/mK9jDTeMy%2BnVpaTpt/c5a/gjyMxg6eKlGW0v8jr7KVZoUkTlWXINfc0MRCuuePU8bkcFZ9CxXQIKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA5jXLprY6lcLxJDAFQ%2B5r4fM8Q6dWviOsYtL7rno0KfM4Lo3%2Bp5d5RJJJOe351%2BT1MXJTdV7y1%2B/U%2B4SUIKMdrHUfDm6eHVWs3O2K4UnH%2B0P/rV9jwfjvY4j2UnpJP8ABP8AzPGz6inGNRdP%2BAd14dJ8h1H3UkZR%2Bdfe5BdKceidl%2BB8vivjTXY1q%2BiOcKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAG5NK7ewwycUbLUlnKeL4sR3GTlZ4sEj1ByK/PeKoToSqSgtJRd77Xsevl8ueyj0ZwghTjOcV%2BSu3Oot6H1kKmiT3NPw2gXVY5lyWXO0erYwBXt5LVlTxcJtX3SXqrP7jgzOaVBwZ6PpNv9mtljyCcZY%2BpPWv3DKsDLBYdUpO77nyE5cxcya9MjQWkIWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAI5HCKzEgBRkn0qZSUFeRSVzCm1iS/EX9g3%2BnysCfMEpJyMdMDkc964p4jn/hGqpdyOa5jv4vsOp27WVyw%2BUbtyOR/dbv9OtebmmEhmdJ4arpLo/6t37mlGXsJLkOU1PSpbGYiZPkJ4I6Y9a/Es3yPF5diJU5x927s9NVd22bPpcLi4ThdvU6Xwpo8VvCLyVP3hGUBPQetfoXB/D7oxWJxHxPbytdPr6Hi5hinWnZF261mTe8Gk2TX0qnDNvCRR%2Bu5j/Jcmv0SNa%2Bi2R5vLbRhY6vJbKI9cvNNjuJJNsYikwCDgAANyTTVXUTpvc20Oc1uRcfQAUAFABQAUAFABQAUAFABQAUAFABQAUAIxxyaAOb1G61K5vgmmXtgsIDBxIdxL54GAeOK83EYqEm4Rmk15o7o04wgpSi3fyK1zZ3LIPtuk2VztGA9qdsi/TPP61zwnOWns0/PUjrfmaJLecvutHzdKvLW867Zox6j%2B8PcfnXTGco0%2BSUbolqDfuuxqWUIeMRykXMJ5RmGcj0/D1q3h6GIp8tSOnZmcpuD0Y3UkJUxs3lWijDbQct/sjHOK1dGKhyRVkPnSV%2BpkXE/SyLTQRbcJaWa7pWHuR90flUpqK5bGsIcy5n%2BJFHY6goAs9C0%2B2G4MJbqTc5I5BOO/wCNZ1IyTvHQpuD0b%2B419AutTE9xDq8tjv3gQ%2BQ33hjJ4PP/AOquinUdvet8jKrSpRs6d/O5tocitznHUAFABQAUAFABQBh%2BI59dT7JFocVs8ks2yd7jIWNMEluOSc4FAHE%2BGvFfjjWU1QwWumMdM1M2EyKWLOA6gyD0wCTg%2BhoA2vAXiTVdf1fxJZXyQxR6Xe/ZYTF1cbQ24/nQBkWXjfxBd6F411IQ2Snw9dzwQBckTCJAxLZ6ZBxxQBreFNZ8W6ra6HqUyaW1pqMQmmjRmWSJCmQRnrzwfrQB20fQ8554oAfQAlAHk3xZ8IKssmvabFsP/LzHHxnn74x%2Bor4/iDL73qUdH1t8z6vIswppqlXimul0cDaa/rVsALbV7yFVGFUSnb%2BR4r5SGaVsOuX2kr%2BrPqZYDCVXzOKt6L/I6Gz%2BIersYl1CG1vY0YEM67WQ%2BoIr0qHEmKpu1dffv%2BZ5lfhfCzV6D/r7j1XwZrkHiDSFvo1wd5V1bBKMPp9RX2%2BWYqOLp86/E%2BLzHBzwlX2cjN%2BJPiu28L2UDNC088zMIkVgMAdTk9Ooq8ZjY0NBYHATxM7HlN98T9eZWj0uC202M8kxpuJ%2BpPevCqZrzfDKx9LHJYR0qHN3viPxFqOY7nWb%2BXecbVlZR%2BABxXNPGVaz5VP7mzvw2XYOlFycb%2Btv8j2P4ReDptLtf7Y1lWkvZQDCshy0C/8AxRzzXv5fhalOLc23fufLZpi6Napy0YpJdkekoeOmK9ZKx5F7i0ALQAUAFABQAUANcgIzN0AyaAPMPgmWE/i/zIZoWk1yeeLejLujYDawyBkHB59qAM/4a6BpmoeJ/Gs99p0jefrAkhdlZA8e1RkE9RkHp6UAY3hiFbTwL8T7OG2mRJb%2B6NrH5T5kjaMKhUEZZSRgYoA3PhnLomk6f4ZWxs9TOpTWUVjcxmGULGSAzM24YUAqenqB3ppID1gyJCm6V1QerHFZ1JxhqwJEZXQMrBlPII71V01cBnnw%2BZs81N/93PNSqkW7XASZFkUo6BlbggjIIpuMWnFicpRalHoeH/E3wo%2BiX5vrSMtp9w/OBnym9Pp6V%2BdZ9lc8NUdWmrn6DkWawxMFSq7o42PIcY65FfNupCbfX5H0lWomlZW%2BZ6R8D74Q3V5pTnHmDzAPccH/AD7V9lwnXUW4W/H0Pj%2BJ8PK0a19vI5L4z6p/aHjN7dW3R2ieSuP73Vv1OPwrrzev%2B9sv62KyehKFH2iOLUhM56EelebBTl0PW5pTfNUeh6r8GfBckrDxBqkO2PraxOO/98/0r6LL8Ff3pI%2BaznM1/Dge1J0xXvWS0R8um3qx1AwoAKACgAoAKAEoAGztODigDyr4r%2BL7/TNds7PS5HVLcCa4ZRwxPRSewwDXjYvGOE7RGek6Pdw32m293A2Y5Yw6/QivTw9TngmIuZrW6AazdAOc96U03EDyj492SRWFrfRyXKu9xtcea2w/KT06dq8fNnOMIuPf/MDutAiS58G2EMvmYazjyFYq2No6EV6NJc1GLv0QHnfgS3Nr8YNRtBJO8cCyrH5rljjjua8rD831iwz2DI2jJxXuShzCvykVxbx3Fu0U6LIrdVYZBqalOE1yzVwhKUJc0XYx5/CegTLh9KgBHIZFwf0rhqZRg57QSO6OY4mKXvtmRp/gW20zWYdS0ueeEoSWjfkMCOnqK4KGQwoV/aQlodNfNq1ekqc9Sjp/wu0gXUl7q0s99cTOWYfdXJJPau7%2By4SlzSEs2qqn7OGh0Fr4M8NRHamjWwXHUrk/rXXHCUodDj%2Bu4lNpy0N%2BFUjQRRrhUGAMYAFbpWVkc2sndkq9TUwVtxXuLketWAZFABkeooAKADI9aAFoASpauwK%2Bo3cVlYT3cv3IkZz%2BAqatRU4uT6AeYW2hT698PNY1GeMm%2B1FjcxZ6qqn5F/LP515MsN7ShKf2n/mBqfAzVxe%2BGDp0j5ms2IIJ5CnpW2W1faU0l0Gd9cMkcTSO4VVG5iTjAr0mlfmYXOMfxlcalqL2fhfTTqYgOJZi/lxIfTPevPeLlUm1T6CON%2BMs/iCbQbQa3p9vBGLnMbwTl%2Bdp4IrhxM5ul73cZ6l4X58NaaeP%2BPROn%2B6K9Sh/AjYDy7SrqWy%2BMmszRWs905MgSOIZJOB68AV5tKbWIf8AXQRv65408W6Pm6uvCoiswRuczbiB744roq4irBX6IZ1Gm67JrPhtNV0SCOaVxykjbdpHUZxXVQr%2B0p87AwfCXja%2B8Qa7LpY0qK3e3bFxulIZQDg4A6nNZUMY6krMR0Pi/VrjQ9Ma%2Bgt1mSP76NJgn0xxzW%2BKrOlG6AoNq3iBdEbVRokHCeZ5QmO7bjPp19qiVaapc4Fb4eeLrjxTJPINPht4oflch/myenFRhcVKs9QL/jPXr/QltWtrGK6FxKsKI0mGLnoAMdKvFYmVG1gJ7vUdYtdMSU6KLi8dsGGBwVX3LHHFaurywTa1YzltW8X%2BLtHj%2B16l4YijsF5dkmyV9q4KmMqwd5LQR2fhfW7bX9Fh1Kz3bJMjDdQR1Brtw%2BJVWmpIDlPEXjy70nXLfSpdFeLzZFClnBLqTjIArlr4x0qnL3AfrHiTxdDG1zZeFZWtVG4tNJhyP90HiideslzIDT8CeL7bxTBKgjNteWxHmwk5OD0OfSt8JilX0YHW12gJS6gcF8Vrq4u4rLwtp5UXmqSYYHosY5JPt2/OvNxrc2qa6jJbXS/HtvaR20d/oAiRQoUW7jgDAq6UKqdmhHF%2BDEu/CPxOfStQeJUvgVPljCEscqR%2BORXmYPnwldxl1Fc7z4s3slp4Gv3hYqZMRkj0JANenmdV08PfqO5B8F7aGDwHazRqN1wzySe7biP5AD8KWXU1To83V/8ABBMyP2hP%2BRWsv%2Bvv/wBlNY5jaNG8u/6MDtfC/HhnTR/05p/6CK7aEP3MUFzzvwnn/hd%2BsYJ/5ad/YV51JL6049f%2BAK53fj%2BJX8G6ruPW2fOfpXdjNMNLyHc534EY/wCEMkXJI%2B0uPw4rDAJTwv8AXcLmF4uhk8J/FKz1yEbbS/kAlxwOcBv6GubE8uGrxv1Ks2dZ4pkXW/Eek6BEd0IP225I6FEPyj8W/lXVUarVYwXzE00dcYx5flgfLggivQUFycpNzyTQN3g74qz6XL8tjqI%2BQ57k5T9civGoydDEu%2B1vxGdaVXXPiEzZ32ujpxnp57j%2BYX%2BddkGsRN36Aa/ijxLpXh1Ue/lbzJfliiRd0kh9hW1bEQppNgznPE%2Bvapf%2BGL/y/Ct4lpJbsGlndFKjH3tuc1x1sVOrB8sdBXI/gQxPg45AGbhzgfUUYK7pxfmwuYfxSUD4n%2BHmOfvx9/8AppWGYJfWoX/rULnrm35cE5U17OnI7jueR/BxQnj/AMQAcHY2B2GJOK8bLY2rvt/w4rnsVe6MpanqNnp1o11dy%2BXCvVsZ/IDk/hWdSfLByGea%2BEdbs9X%2BJt9qt8biE%2BWtvpqSW0i7lzycleCf615eEm6tS8hNNanqTsNv8Q79K9WyTvoTzep458aXhn1uyutNaZ7%2B1OHVIJCVxypzt9a8jHUpcynBK9xqfqdY2oWHjzwhc6dCZYrxoAXilgdGjkHswHGe/pXTaeIpcskh8/qcl4B8Vv4KWfw94ktLqGNZS8TLEzbc9ceq55yPWuXC4qdCTp1IvyshOf8ATJPixrsHifwtDNpdrfm2t7kb5pbWSNckEADIyfr0qMxq%2B3o2UHo%2B3qLnZ2/g/X9Mm8JwTedIi2lsqTmSF12kDHcc/hmvSw9T9xG8dktylI4LwzqtlD8V9Q1aV5lsrgyCOU20gBzgD%2BH2ryqMn9Z53HcfP6noPxC1C0g8J3kMsjq91A0cKiJ2Ltj0AJr1Ma17BpLcXN6nOfA%2B9trfQpNOleRbgzM4VoXUEYHQkCufLXy0uVxsHN6mz8VdF/tvwpOFGZ7U%2BchUEk4%2B8B%2BGa3xtJ1IOVleOoNxW7M34L293Nop1zUSz3E%2BIo2IOfKQbQOnrmsctU5w55JXC8baNnoLMCOjfka9NcwuY82%2BN%2BmPJplr4gtcrPp8o3ttOdjHHp2P868jM6dRR5opXByXW50Hw2sZrXw1FdXYc3d632qZmUgkt0z%2BGK6sHTqQpJtK7Hyx6M474tw3lj4y0nxBLC09lBt%2BVY2bkNkg4GBwR19K4MwhUjWjNxbiu3yC6W1zY1nxxpGteHLyx0231Ke7nt3VYhZvleOpP3cfjXRUxEK1F8kH9wc/qU/gdqllFow0p5JTeCV2KeQ%2BMHnrjA6dzWeBq2opNW1Yc3qYvxJ1SyvPiBpN3avLNBZunnulvIQmHyf4efwrPHPnqxkugc3qesrrWmnShqQnJtCm7zBG2MflnPtXpSmvZrToHMeT/AAy1KysPHerXNxJIsN4GWB/s8mGJkz/d4/GvPw3uTvyj5/U9q3p/eFe2IrX1obm1aDzpELfxocMPpUTgpaDTsZh8OZOTq%2Bpdc8Tf/WrJ4aHTQ1Vbl6AfDg/6C%2BqH2aYEfyqXg4Pq/vL%2BtS/lX3A/hzc%2B4avqajHQTdf0pLB07Wu/vH9al/KvuAeHCP8AmMap9fO/%2BtUvB2fuyf3i%2BtS/lX3DZPDEcgCyanqDgcgtICQfbIqvqdO6d394fWpfyr7hW8NIyhG1O/K9CDIDkenSn9UhytXf3j%2BtS/lj9wJ4cK5A1fUQPQSjGPTpThh%2BVNXYvrUv5V9wo8Oc86vqTD0M3/1qX1SPKknsH1qX8q%2B4D4dJJLavqTegMowP0q5UFLdsPrUv5V9wieHCpLDWNT%2BnncfyqfqyWzD61L%2BVfccT8UbldJ02PT7TVb%2BS8vG8sI0wICE4JI/GvOxlqb5OZ6%2BZnKq30X3HT%2BH/AAqlto9pbrqWowCKMDy45sKD3wMeua6sLh1CCSb%2B8ca7j0X3Gg3h7Az/AGxqn4zj/Ctnh7O/M/vL%2BtS/lX3Hn3xBMNzq2neEbbVL2aa7uE%2B0LJLuG3IwOPxP4V5mJ5akowu9%2B5MsRKSs4r7jsL2ysNLNvBc65qUUkg2wxJNlmCjkhQCcAV6Kw7jG/M/vKWIsrcq%2B4jddHaztp/8AhItQeG8XMG2QN5y4zkLtyRz6VX1dTilJv7w%2BstbRX3EOnnw7JPZ2lp4ivGe%2B3m3RJMebs4fA29uh9KawlOKtFv7w%2BtS/lX3E0Npo0k9/Fb%2BIrxJLA5uwJgvkcZ%2BbgDpzUrCqOiYfWpfyr7htrJo13eR2cPiC/MsoDQhpNvmjGcrkDcB7Zqvq0WtQ%2BtS/lX3Db59FtJZhd%2BIb9Ps2BOfNz5LEDhiBx1B5x1FEsOmkrh9al/KvuJ2h0tNQs7A%2BIr1bm9UvbRLNzKo5ZhxyB3%2BooWFiuofWpdl9x1Ntb%2BRAsQdpNoxukOWP1NdJzE9ABQAUAFABQAUAFABQAUAFACMNwIoA5V/APhyXUV1C4t5ri6Vw4eWZm%2BYHI6n1rklg4uXMwOoICj0x1rpVlogIrqOO7t3tnaRRICCUYqw/EdKbXMrAYGl%2BCfDumaquqxWrveAkrLLKzkEjk8nr71xxwUYz5xmF8SLFn16w1LT9ci0rV7S3kMQuoTJBPFkFkfBBHIBypz9a7nZqwjnvCmsmHxlb694q086NBquh24s0kTENtIrP5sQP8JOUYZxkYqUrAanihUufiX4GOi3cNsDBqTiVIPMQZSPsSByd31pgcp4ksdVmh8dQxPNqMkWrafc3awwbGuIEMTSRqAecqrZx2BFAHZ/EBofEMXhyPRXR7xdUguI5o1J8iNclycdPlyO2c0AQfD66stP8I6lpWvps1C2urw3kcy5klZ5pH3Kf41ZWGCPp2xQBz3ha3n0LXPh3Hq5aFLbTtRLeaDmNXMZjVvQ4GAPY0AeyaVqVvqVkl5bbvKfO0sMEgHGcelAF2gAoAKACgAoAKAILqZoVLLGXwjN17jtQBzeneN9Onslu72OSwjZgqmVlbPzbTwjEjB6k46igC6nizRGVX/tCAKwG3OQfvlDx/vAigCmnjG0k1u0gt3t59Pu4yEuY2J2SAt8rDHAYI%2BD/ALB9RQA6bxrpDPLFZ3HmSJBNLuaFxGnl4B3tj5eSOx/lQBYh8WaMRbpNqFqssoQYVyVLMOApIGR15/PFKwFg%2BItHOjx6qb6P7FMCY5QCQwGe2M9j27UJWAxdD8SGa28Q6rIk0sNjdPHEiggNGij7uQASSTnn0zimBMfGdj5sUc8bQxPZLeSTEhlRC6rg4Oc/N2zSsBYufEXh0ybLm7t5HjcqQRnad20j65IH1NCVgFuNf8OzW0TS3EE0MsrRZZS6hlJBHQjggjPT3pgPtdc0a8hmk09ormS0tlmKx4zGrDKjtjIB9OlAGfp3jDQZkeedW093MRJlRckPjDEqSMcgEnpnmgCbTPEXhxo4rtG%2Bx/aHkVVliKMWRiCeR0yDg96AEk8R%2BHZLq2WOVbyaRo1VoYi5UPH5isxx8oIyc0AQXniTTf7JF1cyWb3EsUgt/JZpFOC2PmKjBwpIzjkN6UAbXhcOPDlgZJGkkNsjMzdSSOaANigAoAKACgAoAKAIbpN8bJu25QjOemaAONXwJYgQZuWysbxTsiKvnI7hyDjvkYz6GgAi%2BH%2BnhszXV1MGOXDYG4eaZAPYc4//AF0ARL8PLVY5Y11O5VX2sAEGVkXfg/TD4x3wKALi%2BC4Ulmkj1GbM8E0UgIHPmHOfbn/CgCCw%2BH%2Bn2qW8b3MssdrOJYlPHyhy%2B0%2Bo3EflQBcTwjCNI03TmupCtijpvAGXV1ZWyO3DUAP0vQxF4cvdLZTbi5ef5zyVDMQD/wB84NAFGfwPZzRqIrtrfFgLImCMKSA6tv8ArlBQBHJ8PtLm8zzbm6beWwA2MbpFducd8Yz7mgBYPAkEdxLJ/aNxseczLHtAEZMjvx7Zcj8BQBo6J4XtdIt72K3uJdlxbRwYYA7QisM%2B5JJPNAFNfA9gIrGPzTsgtmt5gEVfPVip5x0PyAZ9DQA6z8FW9tIji9kfy43iUuoyis7MCD2ILde9AC6f4GttPuraayvZIltlhRU2DkRxlOfUncTmgCofh7amGSJtUuSrEso2jCkxlD9fvZHpz60AdjYW6WllHah9wihCAkdgMZNAFygAoAKACgAoAKAEwM5oAMCgBNi5zz%2BdACeWuf4v%2B%2BjQAuxfT9aAF2jOaAGrGinKrigBwUDoKADA9KADA9KADA7CgBCoJBI6dKAFwB2FACFFOcjrQAbF9/zoANi/7X/fRoAAigYAAFADqACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAA/9k='/%3E%0A%3Cg clip-path='url(%23c2)'%3E%0A%3Cpath d='M105.4 610.7h1v.9h-1v-.9Z' class='g4'/%3E%0A%3Cpath d='M106.4 611.1H221.9' class='g5'/%3E%0A%3C/g%3E%0A%3Cg clip-path='url(%23c3)'%3E%0A%3Cpath d='M310.8 610.7h.9v.9h-.9v-.9Z' class='g4'/%3E%0A%3Cpath d='M311.7 611.1H419' class='g5'/%3E%0A%3C/g%3E%0A%3Cg clip-path='url(%23c4)'%3E%0A%3Cpath d='M640 610.7h.9v.9H640v-.9Z' class='g4'/%3E%0A%3Cpath d='M640.9 611.1h63.3' class='g5'/%3E%0A%3C/g%3E%0A%3Cg clip-path='url(%23c5)'%3E%0A%3Cpath d='M794 610.7h1v.9h-1v-.9Z' class='g4'/%3E%0A%3Cpath d='M795 611.1H903.1' class='g5'/%3E%0A%3C/g%3E%0A%3Cpath d='M357.6 651h.9v.9h-.9V651Z' class='g4'/%3E%0A%3Cpath clip-path='url(%23c6)' d='M358.5 651.5H903.1' class='g5'/%3E%0A%3Cpath d='M245.7 695h91.7v19.3H245.7V695Z' class='g6'/%3E%0A%3Cpath d='M486 695h91.6v19.3H486V695Z' class='g6'/%3E%0A%3Cpath d='M725.3 695H817v19.3H725.3V695Z' class='g6'/%3E%0A%3Cpath d='M167.8 776.6H626.2v24.8H167.8V776.6Z' class='g6'/%3E%0A%3Cpath d='M316.3 847.2H591.4V872H316.3V847.2Z' class='g6'/%3E%0A%3Cg clip-path='url(%23c7)'%3E%0A%3Cpath d='M336.5 922.4h.9v.9h-.9v-.9Z' class='g4'/%3E%0A%3Cpath d='M337.4 922.9H903.1' class='g5'/%3E%0A%3C/g%3E%0A%3Cpath d='M373.2 973.7h.9v1h-.9v-1Z' class='g4'/%3E%0A%3Cpath clip-path='url(%23c8)' d='M374.1 974.2h529' class='g5'/%3E%0A%3Cpath d='M463 741.8h45.9V761H463V741.8Z' class='g6'/%3E%0A%3Cpath d='M617.1 741.8h45.8V761H617.1V741.8Z' class='g6'/%3E%0A%3Cpath d='M772.9 741.8h45.9V761H772.9V741.8Z' class='g6'/%3E%0A%3Cpath d='M69.7 1098.4h91.7V1115H69.7v-16.6Z' class='g6'/%3E%0A%3Cpath d='M181.5 1098.4h91.7V1115H181.5v-16.6Z' class='g6'/%3E%0A%3Cpath d='M293.4 1098.4h91.7V1115H293.4v-16.6Z' class='g6'/%3E%0A%3Cpath d='M405.3 1098.4H497V1115H405.3v-16.6Z' class='g6'/%3E%0A%3Cpath d='M538.2 1098.4h91.7V1115H538.2v-16.6Z' class='g6'/%3E%0A%3Cpath d='M671.2 1098.4h91.7V1115H671.2v-16.6Z' class='g6'/%3E%0A%3Cpath d='M783.9 1098.4h91.7V1115H783.9v-16.6Z' class='g6'/%3E%0A%3C/svg%3E"
              />
            {/* </div> */}
            <div className="text-container">
              <span
                className="t s0"
                style={{ left: 9, bottom: 1261, letterSpacing: "-0.11px" }}
              >
                Reg.{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 9, bottom: 1244, letterSpacing: "-0.13px" }}
              >
                No{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 36, bottom: 674, letterSpacing: "-0.12px" }}
              >
                Adm.{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 75, bottom: 674, letterSpacing: "-0.1px" }}
              >
                No.:{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 204,
                  bottom: 674,
                  letterSpacing: "-0.11px",
                  wordSpacing: "-0.03px",
                }}
              >
                Date of Adm{" "}
              </span>
              <span className="t s0" style={{ left: 307, bottom: 674 }}>
                :{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 402,
                  bottom: 674,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                Class in which adm. is sought for{" "}
              </span>
              <span className="t s0" style={{ left: 622, bottom: 674 }}>
                : {getRegistration?.data?.class?.Classes}
              </span>
              <span
                className="t s1"
                style={{ left: 720, bottom: 674, letterSpacing: "-0.12px" }}
              >
                स{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 740,
                  bottom: 674,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Session{" "}
              </span>
              <span className="t s0" style={{ left: 805, bottom: 674 }}>
                : {getRegistration?.data?.session_data?.Name}
              </span>
              <span
                className="t s0"
                style={{ left: 60, bottom: 637, letterSpacing: "-0.05px" }}
              >
                (a){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 82, bottom: 637, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 85, bottom: 637, letterSpacing: "-0.1px" }}
              >
                वाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 125, bottom: 637, letterSpacing: "-0.08px" }}
              >
                का{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 144, bottom: 637, letterSpacing: "-0.06px" }}
              >
                पूरा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 165, bottom: 637, letterSpacing: "-0.11px" }}
              >
                नाम{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 60,
                  bottom: 614,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                Name of the Child in full (in Capital{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 60, bottom: 591, letterSpacing: "-0.09px" }}
              >
                Letters):{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 365, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 63, bottom: 365, letterSpacing: "-0.1px" }}
              >
                वाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 103, bottom: 365, letterSpacing: "-0.08px" }}
              >
                का{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 122, bottom: 365, letterSpacing: "-0.12px" }}
              >
                आधार{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 160, bottom: 365, letterSpacing: "-0.09px" }}
              >
                संया{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 196,
                  bottom: 365,
                  letterSpacing: "-0.11px",
                  wordSpacing: "-0.95px",
                }}
              >
                Student Aadhar No.{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 396,
                  bottom: 365,
                  letterSpacing: "-0.11px",
                  wordSpacing: "-0.95px",
                }}
              >
                {getRegistration?.data?.aadhar_no}
              </span>
              {/* <span
          className="t s0"
          style={{ left: 60, bottom: 342, letterSpacing: "-0.13px" }}
        >
          No.{" "} {getRegistration?.data?.aadhar_no}
        </span> */}
              <span
                className="t s1"
                style={{ left: 60, bottom: 314, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 63, bottom: 314, letterSpacing: "-0.1px" }}
              >
                वाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 103, bottom: 314, letterSpacing: "-0.08px" }}
              >
                का{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 122, bottom: 314, letterSpacing: "-0.14px" }}
              >
                र{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 144, bottom: 314, letterSpacing: "-0.1px" }}
              >
                समूह{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 174,
                  bottom: 314,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Blood Group of the Student{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 394,
                  bottom: 314,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.blood_group}
              </span>

              {/* <span
          className="t s0"
          style={{ left: 60, bottom: 291, letterSpacing: "-0.11px" }}
        >
          Student{" "}
        </span> */}
              <span
                className="t s2"
                style={{ left: 83, bottom: 1260, letterSpacing: "-0.13px" }}
              >
                {getRegistration?.data?.registration_num}
              </span>
              <span
                className="t s3"
                style={{
                  left: 690,
                  bottom: 1264,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                *To be filled by{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 690,
                  bottom: 1249,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                Parents Do not leave any entry vacant.{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 690,
                  bottom: 1234,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                Every entry will be filed as per documents.{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 690,
                  bottom: 1220,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                failing which the form will be disqualified.{" "}
              </span>
              <span
                className="t s4"
                style={{
                  // left: 354,
                  bottom: 1085,
                  width: "100%",
                  textAlign: "center",
                  letterSpacing: "-0.11px",
                  wordSpacing: "-0.03px",
                }}
              >
                {Automationdata?.data?.[0]?.affiliated}
              </span>
              <span
                className="t s5"
                style={{
                  width: "98%",
                  textAlign: "center",
                  background: "#f5f5f5",
                  bottom: 1045,
                  letterSpacing: "-0.16px",
                  wordSpacing: "-0.02px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  padding: "10px",
                  fontSize: "14px",
                }}
              >
                {Automationdata?.data?.[0]?.aboutUs}
              </span>
              <span
                className="t s5"
                style={{
                  bottom: 1015,
                  width: "100%",
                  textAlign: "center",
                  letterSpacing: "-0.18px",
                  wordSpacing: "-0.02px",
                }}
              >
                {Automationdata?.data?.[0]?.schoolAddress} Tel :{" "}
                {Automationdata?.data?.[0]?.contact_number}
              </span>
              <span
                className="t s6"
                style={{ left: 423, bottom: 990, letterSpacing: "-0.21px" }}
              >
                Session : {getRegistration?.data?.session_data?.Name}
              </span>

<div style={{position:"absolute",top:'415px', left:'100px'}}>
              <p style={{color:'#000', fontWeight:'600'}}>Affix Photo of Father</p>
              </div>
              <div style={{position:"absolute",top:'415px', left:'390px'}}>
              <p style={{color:'#000', fontWeight:'600'}}>Affix Photo of Mother</p>
              </div>
              <div style={{position:"absolute",top:'415px', left:'680px'}}>
              <p style={{color:'#000', fontWeight:'600'}}>Affix Photo of Student</p>
              </div>
              <span
                className="t s0"
                style={{
                  left: 91,
                  bottom: 848,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              ></span>
              <span
                className="t s0"
                style={{
                  left: 386,
                  bottom: 848,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              ></span>

              <span
                className="t s0"
                style={{
                  left: 690,
                  bottom: 848,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.02px",
                }}
              ></span>
              <span
                className="t s7"
                style={{ left: 23, bottom: 699, letterSpacing: "-0.18px" }}
              >
                का{" "}
              </span>
              <span
                className="t s7"
                style={{ left: 54, bottom: 699, letterSpacing: "-0.2px" }}
              >
                जसमे{" "}
              </span>
              <span
                className="t s7"
                style={{ left: 96, bottom: 699, letterSpacing: "-0.17px" }}
              >
                वेश{" "}
              </span>
              <span
                className="t s7"
                style={{ left: 129, bottom: 699, letterSpacing: "-0.17px" }}
              >
                चािहए{" "}
              </span>

              <span
                className="t s2"
                style={{
                  left: 359,
                  bottom: 636,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.student_full_name}
              </span>
              <span
                className="t s0"
                style={{ left: 60, bottom: 570, letterSpacing: "-0.05px" }}
              >
                (b){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 82, bottom: 570, letterSpacing: "-0.1px" }}
              >
                लग{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 107,
                  bottom: 570,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Sex{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 173, bottom: 570, letterSpacing: "-0.09px" }}
              >
                पु"ष{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 202,
                  bottom: 570,
                  letterSpacing: "-0.08px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Male{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 248, bottom: 570, letterSpacing: "-0.13px" }}
              >
                {getRegistration?.data?.gender === "Male" ||
                getRegistration?.data?.gender === "male"
                  ? "Yes"
                  : ""}
              </span>

              <span
                className="t s1"
                style={{ left: 403, bottom: 570, letterSpacing: "-0.08px" }}
              >
                $ी{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 425,
                  bottom: 570,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Female{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 490, bottom: 570, letterSpacing: "-0.13px" }}
              >
                {getRegistration?.data?.gender === "Female" ||
                getRegistration?.data?.gender === "female"
                  ? "Yes"
                  : ""}
              </span>

              <span
                className="t s1"
                style={{ left: 647, bottom: 570, letterSpacing: "-0.12px" }}
              >
                अ'य{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 677,
                  bottom: 570,
                  letterSpacing: "-0.08px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Other{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 725, bottom: 570, letterSpacing: "-0.13px" }}
              >
                {getRegistration?.data?.gender === "Other" ||
                getRegistration?.data?.gender === "other"
                  ? "Yes"
                  : ""}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 485, letterSpacing: "-0.09px" }}
              >
                श(दो{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 90, bottom: 485, letterSpacing: "-0.17px" }}
              >
                मे{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 100,
                  bottom: 485,
                  letterSpacing: "-0.08px",
                  wordSpacing: "-0.03px",
                }}
              >
                / In words{" "}
              </span>
              {(() => {
                const dobString = getRegistration?.data?.date_of_birth;
                if (!dobString) return null;

                // Convert ISO or any valid date string to Date object
                const dob = new Date(dobString);

                // Extract parts
                const day = dob.getDate();
                const month = dob.toLocaleString("default", { month: "long" });
                const year = dob.getFullYear();

                // Helper function to convert number to words
                const numberToWords = (num) => {
                  const a = [
                    "",
                    "One",
                    "Two",
                    "Three",
                    "Four",
                    "Five",
                    "Six",
                    "Seven",
                    "Eight",
                    "Nine",
                    "Ten",
                    "Eleven",
                    "Twelve",
                    "Thirteen",
                    "Fourteen",
                    "Fifteen",
                    "Sixteen",
                    "Seventeen",
                    "Eighteen",
                    "Nineteen",
                  ];
                  const b = [
                    "",
                    "",
                    "Twenty",
                    "Thirty",
                    "Forty",
                    "Fifty",
                    "Sixty",
                    "Seventy",
                    "Eighty",
                    "Ninety",
                  ];

                  if (num < 20) return a[num];
                  if (num < 100)
                    return (
                      b[Math.floor(num / 10)] +
                      (num % 10 ? " " + a[num % 10] : "")
                    );
                  if (num < 1000)
                    return (
                      a[Math.floor(num / 100)] +
                      " Hundred" +
                      (num % 100 ? " and " + numberToWords(num % 100) : "")
                    );
                  if (num < 10000)
                    return (
                      a[Math.floor(num / 1000)] +
                      " Thousand" +
                      (num % 1000 ? " " + numberToWords(num % 1000) : "")
                    );
                  return num;
                };

                // Convert parts to words
                const dayInWords = numberToWords(day);
                const yearInWords = numberToWords(year);

                return (
                  <span
                    className="t s2"
                    style={{
                      left: 174,
                      bottom: 485,
                      letterSpacing: "-0.1px",
                      wordSpacing: "-0.04px",
                    }}
                  >
                    {`${dayInWords} ${month} ${yearInWords}`}
                  </span>
                );
              })()}

              <span
                className="t s1"
                style={{ left: 60, bottom: 439, letterSpacing: "-0.1px" }}
              >
                का{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 88, bottom: 439, letterSpacing: "-0.17px" }}
              >
                मे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 100, bottom: 439, letterSpacing: "-0.1px" }}
              >
                वेश{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 130, bottom: 439, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 145, bottom: 439, letterSpacing: "-0.13px" }}
              >
                समय{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 176, bottom: 439, letterSpacing: "-0.07px" }}
              >
                {/* {ageAsOn} */} {Automationdata?.data?.[0]?.enq_dob
    ? (() => {
        const date = new Date(Automationdata.data[0].enq_dob);
        const day = String(date.getDate()).padStart(2, "0");
        const monthNamesHindi = [
          "जनवरी", "फ़रवरी", "मार्च", "अप्रैल", "मई", "जून",
          "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"
        ];
        const month = monthNamesHindi[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      })()
    : "N/A"}
              </span>

              <span
                className="t s1"
                style={{ left: 285, bottom: 439, letterSpacing: "-0.08px" }}
              >
                को{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 305, bottom: 439, letterSpacing: "0.02px" }}
              >
                आयु{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 50,
                  bottom: 415,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                Age of the student as on  {Automationdata?.data?.[0]?.enq_dob
    ? (() => {
        const date = new Date(Automationdata.data[0].enq_dob);
        const day = String(date.getDate()).padStart(2, "0");
        const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      })()
    : "N/A"}{" "}
              </span>
              {(() => {
                const dobString = getRegistration?.data?.date_of_birth;
                if (!dobString) return null;

                // Convert DOB to Date object
                const dob = new Date(dobString);

                // Fixed date: 31 July 2025
                const referenceDate = new Date("2025-07-31");

                // Calculate year, month, day difference
                let ageYears = referenceDate.getFullYear() - dob.getFullYear();
                let ageMonths = referenceDate.getMonth() - dob.getMonth();
                let ageDays = referenceDate.getDate() - dob.getDate();

                // Adjust if negative month or day difference
                if (ageDays < 0) {
                  ageMonths--;
                  const prevMonth = new Date(
                    referenceDate.getFullYear(),
                    referenceDate.getMonth(),
                    0
                  );
                  ageDays += prevMonth.getDate();
                }

                if (ageMonths < 0) {
                  ageYears--;
                  ageMonths += 12;
                }

                return (
                  <span
                    className="t s2"
                    style={{
                      left: 330,
                      bottom: 415,
                      letterSpacing: "-0.11px",
                      wordSpacing: "-0.03px",
                    }}
                  >
                    {`${ageYears} Years ${ageMonths} Months ${ageDays} Days`}
                  </span>
                );
              })()}

              <span className="t s0" style={{ left: 39, bottom: 638 }}>
                1{" "}
              </span>
              <span className="t s0" style={{ left: 39, bottom: 530 }}>
                2{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 523, letterSpacing: "-0.12px" }}
              >
                ज'म{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 88, bottom: 523, letterSpacing: "-0.11px" }}
              >
                ,त.थ{" "}
              </span>
              <span className="t s0" style={{ left: 118, bottom: 523 }}>
                (
              </span>
              <span
                className="t s1"
                style={{ left: 123, bottom: 523, letterSpacing: "-0.09px" }}
              >
                अंको{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 153, bottom: 523, letterSpacing: "-0.17px" }}
              >
                मे{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 161,
                  bottom: 523,
                  letterSpacing: "-0.08px",
                  wordSpacing: "-0.02px",
                }}
              >
                ) / Date of Birth:{" "}
              </span>
              {(() => {
                const dobString = getRegistration?.data?.date_of_birth;
                if (!dobString) return null; // no date → show nothing

                // Convert safely to Date object
                const dob = new Date(dobString);

                // Extract parts
                const day = dob.getDate();
                const month = dob
                  .toLocaleString("default", { month: "long" })
                  .slice(0, 3);
                const year = dob.getFullYear();

                return (
                  <>
                    <span
                      className="t s0"
                      style={{
                        left: 433,
                        bottom: 523,
                        letterSpacing: "-0.08px",
                      }}
                    >
                      Day{" "}
                    </span>
                    <span
                      className="t s0"
                      style={{
                        left: 465,
                        bottom: 523,
                        letterSpacing: "-0.13px",
                      }}
                    >
                      {day || ""}
                    </span>

                    <span
                      className="t s0"
                      style={{
                        left: 572,
                        bottom: 523,
                        letterSpacing: "-0.1px",
                      }}
                    >
                      Month{" "}
                    </span>
                    <span
                      className="t s0"
                      style={{
                        left: 619,
                        bottom: 523,
                        letterSpacing: "-0.12px",
                      }}
                    >
                      {month || ""}
                    </span>

                    <span
                      className="t s0"
                      style={{
                        left: 740,
                        bottom: 523,
                        letterSpacing: "-0.07px",
                      }}
                    >
                      Year{" "}
                    </span>
                    <span
                      className="t s0"
                      style={{
                        left: 775,
                        bottom: 523,
                        letterSpacing: "-0.13px",
                      }}
                    >
                      {year || ""}
                    </span>
                  </>
                );
              })()}

              <span className="t s0" style={{ left: 39, bottom: 367 }}>
                3{" "}
              </span>
              <span className="t s0" style={{ left: 39, bottom: 316 }}>
                4{" "}
              </span>
              <span className="t s0" style={{ left: 39, bottom: 264 }}>
                5{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 263, letterSpacing: "-0.09px" }}
              >
                /या{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 84, bottom: 263, letterSpacing: "-0.13px" }}
              >
                आप{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 111, bottom: 263, letterSpacing: "-0.1px" }}
              >
                सामा'य{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 155, bottom: 263, letterSpacing: "-0.08px" }}
              >
                0ेणी{" "}
              </span>
              <span className="t s0" style={{ left: 183, bottom: 263 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 191, bottom: 263, letterSpacing: "-0.1px" }}
              >
                अनुसू,चत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 246, bottom: 263, letterSpacing: "-0.11px" }}
              >
                जनजा,त{" "}
              </span>
              <span className="t s0" style={{ left: 296, bottom: 263 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 304, bottom: 263, letterSpacing: "-0.11px" }}
              >
                ओबीसी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 349, bottom: 263, letterSpacing: "-0.19px" }}
              >
                से{" "}
              </span>
              <span className="t s0" style={{ left: 363, bottom: 263 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 371, bottom: 263, letterSpacing: "-0.15px" }}
              >
                आ4थक{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 414, bottom: 263, letterSpacing: "-0.12px" }}
              >
                5प{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 437, bottom: 263, letterSpacing: "-0.19px" }}
              >
                से{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 451, bottom: 263, letterSpacing: "-0.11px" }}
              >
                कमजोर{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 495, bottom: 263, letterSpacing: "-0.48px" }}
              >
                वग6{" "}
              </span>
              <span className="t s0" style={{ left: 514, bottom: 263 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 522, bottom: 263, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 526, bottom: 263, letterSpacing: "-0.09px" }}
              >
                द7यांगजन{" "}
              </span>
              <span className="t s0" style={{ left: 581, bottom: 263 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 589, bottom: 263, letterSpacing: "-0.1px" }}
              >
                इकलौती{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 638, bottom: 263, letterSpacing: "-0.1px" }}
              >
                क'या
              </span>
              <span className="t s0" style={{ left: 667, bottom: 263 }}>
                ,{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 675, bottom: 263, letterSpacing: "-0.1px" }}
              >
                यिद{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 699, bottom: 263, letterSpacing: "-0.07px" }}
              >
                हा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 715, bottom: 263, letterSpacing: "-0.07px" }}
              >
                तो{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 731, bottom: 263, letterSpacing: "-0.12px" }}
              >
                माण
              </span>
              <span className="t s0" style={{ left: 761, bottom: 263 }}>
                -
              </span>
              <span
                className="t s1"
                style={{ left: 766, bottom: 263, letterSpacing: "-0.11px" }}
              >
                प{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 786, bottom: 263, letterSpacing: "-0.1px" }}
              >
                संल:{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 818, bottom: 263, letterSpacing: "0.06px" }}
              >
                करे{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 839,
                  bottom: 263,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Do{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 60,
                  bottom: 240,
                  letterSpacing: "-0.11px",
                  wordSpacing: "-0.03px",
                }}
              >
                you belong to Gen./SC/ST/OBC/EWS/Disabled/S.G. Child?{" "}
              </span>
              <span
                className="t s2"
                style={{
                  left: 448,
                  bottom: 240,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                Attach certificate of student{" "}
                {getRegistration?.data?.cast?.category}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 217, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 63, bottom: 217, letterSpacing: "-0.11px" }}
              >
                न;न&lt;ल&lt;खत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 129, bottom: 217, letterSpacing: "-0.13px" }}
              >
                म&gt;{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 141, bottom: 217, letterSpacing: "-0.19px" }}
              >
                से{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 155, bottom: 217, letterSpacing: "-0.07px" }}
              >
                जो{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 173, bottom: 217, letterSpacing: "-0.06px" }}
              >
                लागू{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 199, bottom: 217, letterSpacing: "-0.07px" }}
              >
                हो{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 215, bottom: 217, letterSpacing: "-0.14px" }}
              >
                उसे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 238, bottom: 217, letterSpacing: "-0.09px" }}
              >
                सही{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 263, bottom: 217, letterSpacing: "-0.03px" }}
              >
                (){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 277, bottom: 217, letterSpacing: "0.06px" }}
              >
                करे{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 86, bottom: 199, letterSpacing: "-0.04px" }}
              >
                सामा'य{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 125, bottom: 199, letterSpacing: "-0.02px" }}
              >
                0ेणी{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 88,
                  bottom: 185,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                Gen. Cat.{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 100,
                  bottom: 169,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.cast?.category === "General" ||
                getRegistration?.data?.cast?.category === "general"
                  ? "Yes"
                  : ""}
              </span>
              <span
                className="t s9"
                style={{ left: 204, bottom: 199, letterSpacing: "-0.03px" }}
              >
                अनु.जा,त{" "}
              </span>
              <span
                className="t s3"
                style={{ left: 219, bottom: 185, letterSpacing: "-0.06px" }}
              >
                SC{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 219,
                  bottom: 169,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.cast?.category === "SC" ||
                getRegistration?.data?.cast?.category === "sc"
                  ? "Yes"
                  : ""}
              </span>

              <span
                className="t s9"
                style={{ left: 307, bottom: 199, letterSpacing: "-0.04px" }}
              >
                अनु.जनजा,त{" "}
              </span>
              <span
                className="t s3"
                style={{ left: 331, bottom: 185, letterSpacing: "-0.05px" }}
              >
                ST{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 307,
                  bottom: 169,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.cast?.category === "ST" ||
                getRegistration?.data?.cast?.category === "st"
                  ? "Yes"
                  : ""}
              </span>
              <span
                className="t s9"
                style={{ left: 428, bottom: 199, letterSpacing: "-0.03px" }}
              >
                ओ.बी.सी{" "}
              </span>
              <span
                className="t s3"
                style={{ left: 437, bottom: 185, letterSpacing: "-0.06px" }}
              >
                OBC{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 437,
                  bottom: 169,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.cast?.category === "OBC" ||
                getRegistration?.data?.cast?.category === "obc"
                  ? "Yes"
                  : ""}
              </span>
              <span
                className="t s8"
                style={{ left: 521, bottom: 199, letterSpacing: "-0.05px" }}
              >
                आ4थक{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 559, bottom: 199, letterSpacing: "-0.02px" }}
              >
                5प{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 578, bottom: 199, letterSpacing: "-0.14px" }}
              >
                से{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 591, bottom: 199, letterSpacing: "-0.04px" }}
              >
                कमजोर{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 629, bottom: 199, letterSpacing: "-0.38px" }}
              >
                वग6{" "}
              </span>
              <span
                className="t s3"
                style={{ left: 569, bottom: 185, letterSpacing: "-0.05px" }}
              >
                EWS{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 569,
                  bottom: 169,
                  letterSpacing: "-0.03px",
                  wordSpacing: "-0.03px",
                }}
              >
                {getRegistration?.data?.cast?.category === "EWS" ||
                getRegistration?.data?.cast?.category === "ews"
                  ? "Yes"
                  : ""}
              </span>
              <span
                className="t s8"
                style={{ left: 692, bottom: 199, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s8"
                style={{ left: 696, bottom: 199, letterSpacing: "-0.03px" }}
              >
                द7यांगजन{" "}
              </span>
              <span
                className="t s3"
                style={{ left: 690, bottom: 185, letterSpacing: "-0.02px" }}
              >
                Disabled{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 794, bottom: 199, letterSpacing: "-0.03px" }}
              >
                इकलौती{" "}
              </span>
              <span
                className="t s8"
                style={{ left: 836, bottom: 199, letterSpacing: "-0.03px" }}
              >
                क'या{" "}
              </span>
              <span
                className="t s3"
                style={{
                  left: 802,
                  bottom: 185,
                  letterSpacing: "-0.02px",
                  wordSpacing: "-0.04px",
                }}
              >
                SG Child{" "}
              </span>
            </div>
          </section>
        </div>

        <div className="page-container">
          <section
            className="page"
            style={{ width: 960, height: 1286 }}
            aria-label="Page 3"
          >
            <div
              id="pg3Overlay"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 1,
                backgroundColor: "rgba(0,0,0,0)",
                WebkitUserSelect: "none",
              }}
            />
            <div style={{ display: "inline-block", width: "8%",verticalAlign:'top' }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "100%",
                      marginBottom: 0,
                      textAlign:'right',
                      paddingRight:'12px',
                      marginTop:'20px'
                    }}
                  >
                    6.
                  </p>
                </div>
                <div style={{width:'88%', display:'inline-block'}}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                margin: "20px auto",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      width: "60%",
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      color: "#000",
                    }}
                  >
                    माता / पिता का ब्योरा / <br />
                    Details of Parents
                  </th>
                  <th
                    style={{
                      width: "20%",
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    माता / Mother
                  </th>
                  <th
                    style={{
                      width: "20%",
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    पिता / Father
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (i) नाम / Name (In Capital Letters)
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_full_name}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_full_name}
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (ii) शैक्षिक अहता / Qualification
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_qualification}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_qualification}
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (iii) राष्ट्रीयता / Nationality
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  ></td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  ></td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (iv) व्यवसाय / पद Occupation Designation
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_occupation}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      color: "#000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_occupation}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (iv) कार्यालय का का नाम नाम, पूरा पूरा पता पता व दूरभाष
                    दूरभाष <br /> Name of office & full address
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_company_address}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      color: "#000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_company_address}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (iv) मोबाइल <br /> Mobile No.
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_mobile_no}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      color: "#000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_mobile_no}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      width: "30%", // optional, to control column width
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    (iv) ईमेल आईडी
                    <br /> Email id
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "35%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_email}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "35%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_email}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      width: "30%", // optional, to control column width
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    (viii) स्थायी पता पता
                    <br /> Permanent Address
                  </td>

                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "35%", // optional
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.permanent_address}
                  </td>

                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "35%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.permanent_address}
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      width: "30%", // optional, to control column width
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    (ix) वर्तमान पता पता / Present Address
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "35%", // optional
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.contact_address}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "35%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.contact_address}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (x) आधार नं० नं० / Aadhar No
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.mother_aadhar_no}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      color: "#000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.father_aadhar_no}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      color: "#000",
                    }}
                  >
                    (xi) वार्षिक आय / Annual Income
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "center",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {/* {getRegistration?.data?.mother_aadhar_no} */}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      color: "#000",
                      padding: "8px",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {/* {getRegistration?.data?.father_aadhar_no} */}
                  </td>
                </tr>
              </tbody>
            </table>
            
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                margin: "20px auto",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      width: "44%",
                      padding: "8px",
                      textAlign: "left",
                      color: "#000",
                    }}
                  >
                    स्थानीय अभिभावक का विवरण / Personal Information
                  </th>
                  <th
                    style={{
                      width: "56%",
                      padding: "8px",
                      textAlign: "left",
                      color: "#000",
                    }}
                  ></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      width: "30%", // optional, to control column width
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    (i) (स्थानीय अभिभावक का नाम)
                    <br /> Name of Local Guardian
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "70%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.guardian_name}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      width: "30%", // optional, to control column width
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    (ii) संबंध
                    <br /> Relation
                  </td>

                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "70%", // optional
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.guardian_relation}
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      width: "30%", // optional, to control column width
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    (iii) पता एवं दूरभाष सं􀀒या / Address & Contact No.
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      textAlign: "left",
                      width: "70%", // optional
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      color: "#000",
                    }}
                  >
                    {getRegistration?.data?.guardian_mobile_no}
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </section>
        </div>
        <div className="page-container">
          <section
            className="page"
            style={{ width: 960, height: 1286 }}
            aria-label="Page 3"
          >
            {/* <div
        id="pg3Overlay"
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 1,
          backgroundColor: "rgba(0,0,0,0)",
          WebkitUserSelect: "none"
        }}
      /> */}

            <div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "5%",
                      marginBottom: 0,
                    }}
                  >
                    7.
                  </p>
                </div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "35%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>अन्तिम विद्यालय का नाम व पता जहाँ पढ़ा हो</b>
                    <br />
                    <b>Name & Address of School last attended</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "63%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "bottom",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    {getRegistration?.last_school_name}, {" "}
                    {getRegistration?.last_school_address}
                    ...................................................................................................................................
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "5%",
                      marginBottom: 0,
                    }}
                  >
                    8.
                  </p>
                </div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "35%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>पिछली कक्षा जिसमें विद्यार्थी अध्ययनरत रहा है</b>
                    <br />
                    <b>Last attended class</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "63%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    {" "}
                    {getRegistration?.data?.last_school_class}
                    ...................................................................................................................................
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "5%",
                      marginBottom: 0,
                    }}
                  >
                    9.
                  </p>
                </div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "50%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>
                      क्या पिछला विद्यालय सी.बी.एस.ई. से सम्बद्ध था (यदि हाँ तो
                      सम्बद्धता संख्या)
                    </b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "48%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "bottom",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    ....................................................................................................
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "6%",
                      marginBottom: 0,
                    }}
                  >
                    10.
                  </p>
                </div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "54%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>
                      Whether last school was CBSE affiliated (if yes,
                      Affiliation No.)
                    </b>
                    <br />
                    <b>
                      यदि पिछला विद्यालय CBSE से सम्बद्ध नहीं है तो सम्बंधित
                      बोर्ड का नाम दर्शाये
                    </b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "43%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    {" "}
                    {getRegistration?.data?.last_school_board}
                    .........................................................................................
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div>
                  <div style={{ display: "inline-block", width: "3%" }}>
                    <p
                      style={{
                        padding: "0px",
                        width: "5%",
                        marginBottom: 0,
                      }}
                    >
                      11.
                    </p>
                  </div>
                  <div style={{ display: "inline-block", width: "97%" }}>
                    <p
                      style={{
                        padding: "0px",
                        width: "100%",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        verticalAlign: "middle",
                        display: "inline-block",
                        marginBottom: 0,
                      }}
                    >
                      <b>
                        If the last school was not affiliated with CBSE, specify
                        name of the Board
                      </b>
                    </p>
                  </div>
                </div>
                <div style={{ display: "inline-block", width: "3%" }}></div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "25%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>Last School Udise Code</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "25%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "bottom",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  > 
                    ............................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "20%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>& Student PEN</b>
                    <br />
                    <b>number</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "25%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    {" "}
                    {getRegistration?.data?.pen_number} 
                    .................................................
                  </p>
                </div>
              </div>

              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "5%",
                      marginBottom: 0,
                    }}
                  >
                    12.
                  </p>
                </div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>(a) बिगत परीक्षा परिणाम / Result of last examination</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "25%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  > 
                    ..............................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "22%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>(b)प्रतिशत / Percentage</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "20%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .........................................
                  </p>
                </div>
              </div>

              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div>
                  <div style={{ display: "inline-block", width: "3%" }}>
                    <p
                      style={{
                        padding: "0px",
                        width: "5%",
                        marginBottom: 0,
                      }}
                    >
                      13.
                    </p>
                  </div>
                  <div style={{ display: "inline-block", width: "97%" }}>
                    <p
                      style={{
                        padding: "0px",
                        width: "98%",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        verticalAlign: "middle",
                        display: "inline-block",
                        marginBottom: 0,
                      }}
                    >
                      <b>
                        लिये जाने वाले प्रस्तावित विषय / Subject proposed to
                        offer
                      </b>
                    </p>
                  </div>
                </div>
                <div style={{ display: "inline-block", width: "3%" }}></div>

                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "3%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>1</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  > 
                    .........................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "3%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>2</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .........................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "3%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>3</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .........................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "3%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>4</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .........................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "3%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>5</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .........................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "3%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>6</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .........................................................
                  </p>
                </div>
              </div>

              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "5%",
                      marginBottom: 0,
                    }}
                  >
                    14.
                  </p>
                </div>

                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "32%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>क्या स्थानांतरण प्रमाणपत्र संलग्न है? हाँ / नही</b>
                    <br />
                    <b>Whether the transfer certificate is attached YES / NO</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "10%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    ...............
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "15%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>टी. सी. का दिनांक</b>
                    <br />
                    <b>Date of T.C</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "18%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    ................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "8%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>TC No.</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "15%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    {getRegistration?.data?.tc_number}
                    ....................
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div style={{ display: "inline-block", width: "3%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "5%",
                      marginBottom: 0,
                    }}
                  >
                    15.
                  </p>
                </div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "25%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>मातृभाषा / Mother Tongue</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .....................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "20%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>गृह नगर / Home Town</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "23%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    ......................................
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  margin: "20px auto",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <div>
                  <div style={{ display: "inline-block", width: "3%" }}>
                    <p
                      style={{
                        padding: "0px",
                        width: "5%",
                        marginBottom: 0,
                        verticalAlign: "top",
                      }}
                    >
                      16.
                    </p>
                  </div>

                  <div style={{ display: "inline-block", width: "97%" }}>
                    <p
                      style={{
                        padding: "0px",
                        width: "98%",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        verticalAlign: "top",
                        display: "inline-block",
                        marginBottom: 0,
                      }}
                    >
                      <b>Details of Siblings (सगे भाई-बहन का विवरण)</b>
                    </p>
                  </div>
                </div>
                <div style={{ display: "inline-block", width: "3%" }}></div>
                <div style={{ display: "inline-block", width: "97%" }}>
                  <p
                    style={{
                      padding: "0px",
                      width: "28%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>स्कूल का नाम जिसमे अध्ययनरत हो</b>
                  </p>

                  <p
                    style={{
                      padding: "0px",
                      width: "70%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .......................................................................................................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                      textAlign: "right",
                      paddingRight: 5,
                    }}
                  >
                    <b>Name (नाम)</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "68%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    .................................................................................................................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "15%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>Class (कक्षा)</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "22%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    ..................................
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "30%",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    <b>Admission No. (पंजीकरण संख्या)</b>
                  </p>
                  <p
                    style={{
                      padding: "0px",
                      width: "25%",
                      textAlign: "left",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      verticalAlign: "top",
                      display: "inline-block",
                      marginBottom: 0,
                    }}
                  >
                    ....................................................
                  </p>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "90%",
                margin: "20px auto",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                lineHeight: "1.4",
              }}
            >
              {/* 17. Result of Previous Class */}
              <div style={{ marginBottom: "15px" }}>
                <b>17. पिछली कक्षा का परिणाम: Result of previous class</b>

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "8px",
                    border: "1px solid black",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid black",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        विषय
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        अधिकतम अंक
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        प्रापांक
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        अंको का प्रतिशत
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        टिप्पणी
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(5)].map((_, i) => (
                      <tr key={i}>
                        <td
                          style={{ border: "1px solid black", height: "28px" }}
                        ></td>
                        <td style={{ border: "1px solid black" }}></td>
                        <td style={{ border: "1px solid black" }}></td>
                        <td style={{ border: "1px solid black" }}></td>
                        <td style={{ border: "1px solid black" }}></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* 18. Transport Facility Required */}
              <div style={{ display: "inline-block", width: "100%" }}>
                <div style={{ width: "50%", display: "inline-block" }}>
                  <b>18. Transport Facility Required</b>
                  <br />
                  यातायात सुविधा का विवरण
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      marginTop: "10px",
                    }}
                  ></div>
                </div>
                <div style={{ width: "50%", display: "inline-block" }}>
                  <p
                    style={{
                      width: "50%",
                      display: "inline-block",
                    }}
                  >
                    Yes <br /> <span style={{ fontSize: "13px" }}>हाँ</span>
                    <input
                      type="text"
                      style={{
                        width: "60px",
                        height: "18px",
                        border: "1px solid black",
                        marginLeft: "5px",
                      }}
                    />
                  </p>
                  <p style={{ width: "50%", display: "inline-block" }}>
                    No <br /> <span style={{ fontSize: "13px" }}>नहीं</span>
                    <input
                      type="text"
                      style={{
                        width: "60px",
                        height: "18px",
                        border: "1px solid black",
                        marginLeft: "5px",
                      }}
                    />
                  </p>
                </div>

                <div
                  style={{
                    marginTop: "10px",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <b>If Yes Please mention Address (with Landmark)</b>
                  <br />
                  <b> (यदि हाँ कृपया पूर्ण पता निकटतम दूरी सहित)</b>

                  <div
                    style={{
                      marginTop: "5px",
                      borderBottom: "1px dotted black",
                      height: "15px",
                      display: "inline-block",
                      width: "50%",
                      marginLeft:'15px',
                    }}
                  ></div>
                </div>

                {/* Distance Section */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "20px",
                    marginTop: "12px",
                  }}
                >
                  <span>Distance</span>

                  {[
                    { label: "0-4Km." },
                    { label: "4-8Km." },
                    { label: "8-12Km." },
                    { label: "12-16Km." },
                  ].map((item, i) => (
                    <div
                      key={i}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span style={{ marginRight: "4px" }}>{item.label}</span>
                      <input
                        type="text"
                        style={{
                          width: "60px",
                          height: "18px",
                          border: "1px solid black",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="page-container">
          <section
            className="page"
            style={{ width: 960, height: 1286 }}
            aria-label="Page 4"
          >
            <div
              id="pg4Overlay"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 1,
                backgroundColor: "rgba(0,0,0,0)",
                WebkitUserSelect: "none",
              }}
            />
            <div id="pg4" style={{ WebkitUserSelect: "none" }}>
              <img
                id="pdf4"
                style={{ width: 960, height: 1286 }}
                src="data:image/svg+xml,%3Csvg viewBox='0 0 960 1286' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%0A%3Cdefs%3E%0A%3CclipPath id='c0'%3E%3Cpath d='M8.8 1286.7V4.3h891V1286.7Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c1'%3E%3Cpath d='M694.7 647.7v-1.6H886v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c2'%3E%3Cpath d='M118 768.7v-1.6H309.3v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c3'%3E%3Cpath d='M694.7 768.7v-1.6H886v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c4'%3E%3Cpath d='M268.3 152.5V151H423.9v1.5Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c5'%3E%3Cpath d='M218.8 195.6v-1.5H374.4v1.5Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c6'%3E%3Cpath d='M40.9 849.4v-1.6H886v1.6Z'/%3E%3C/clipPath%3E%0A%3CclipPath id='c7'%3E%3Cpath d='M40.9 892.5v-1.6H886v1.6Z'/%3E%3C/clipPath%3E%0A%3Cstyle%3E%0A.g0%7Bfill:%23FFF%3B%7D%0A.g1%7Bfill:%23333%3B%7D%0A.g2%7Bfill:none%3Bstroke:%23333%3Bstroke-width:0.916%3Bstroke-linejoin:bevel%3Bstroke-dasharray:1%2C1%3B%7D%0A.g3%7Bfill:%23FFF%3Bstroke:%23000%3Bstroke-width:0.641%3Bstroke-linecap:square%3Bstroke-linejoin:bevel%3B%7D%0A%3C/style%3E%0A%3C/defs%3E%0A%3Cpath clip-path='url(%23c0)' d='M9.2 4.6H899.5V1098.4H9.2V4.6Z' class='g0'/%3E%0A%3Cpath d='M22.9 261.3H885.7v1.8H22.9v-1.8Z' class='g1'/%3E%0A%3Cg clip-path='url(%23c1)'%3E%0A%3Cpath d='M695 646.4h.9v.9H695v-.9Z' class='g1'/%3E%0A%3Cpath d='M695.9 646.9H903.1' class='g2'/%3E%0A%3C/g%3E%0A%3Cg clip-path='url(%23c2)'%3E%0A%3Cpath d='M118.3 767.4h.9v1h-.9v-1Z' class='g1'/%3E%0A%3Cpath d='M119.2 767.9H326.4' class='g2'/%3E%0A%3C/g%3E%0A%3Cg clip-path='url(%23c3)'%3E%0A%3Cpath d='M695 767.4h.9v1H695v-1Z' class='g1'/%3E%0A%3Cpath d='M695.9 767.9H903.1' class='g2'/%3E%0A%3C/g%3E%0A%3Cpath d='M268.7 129.3H423.6v22.9H268.7V129.3Z' class='g0'/%3E%0A%3Cg clip-path='url(%23c4)'%3E%0A%3Cpath d='M268.7 151.3h.9v.9h-.9v-.9Z' class='g1'/%3E%0A%3Cpath d='M422.7 151.3h.9v.9h-.9v-.9Z' class='g1'/%3E%0A%3C/g%3E%0A%3Cpath d='M269.6 151.7H422.7' class='g2'/%3E%0A%3Cpath d='M219.1 172.4h155v22.9h-155V172.4Z' class='g0'/%3E%0A%3Cg clip-path='url(%23c5)'%3E%0A%3Cpath d='M219.1 194.4h1v.9h-1v-.9Z' class='g1'/%3E%0A%3Cpath d='M373.2 194.4h.9v.9h-.9v-.9Z' class='g1'/%3E%0A%3C/g%3E%0A%3Cpath d='M220.1 194.8H373.2' class='g2'/%3E%0A%3Cg clip-path='url(%23c6)'%3E%0A%3Cpath d='M41.3 848.1h.9v1h-.9v-1Z' class='g1'/%3E%0A%3Cpath d='M42.2 848.6H903.1' class='g2'/%3E%0A%3C/g%3E%0A%3Cg clip-path='url(%23c7)'%3E%0A%3Cpath d='M41.3 891.2h.9v.9h-.9v-.9Z' class='g1'/%3E%0A%3Cpath d='M42.2 891.7H903.1' class='g2'/%3E%0A%3C/g%3E%0A%3Cpath d='M22.9 13.8H885.7v1.8H22.9V13.8Z' class='g1'/%3E%0A%3Cpath d='M794 320h91.7v19.3H794V320Z' class='g3'/%3E%0A%3Cpath d='M794 345.7h91.7v19.2H794V345.7Z' class='g3'/%3E%0A%3Cpath d='M794 371.3h91.7v19.3H794V371.3Z' class='g3'/%3E%0A%3Cpath d='M794 397h91.7v19.3H794V397Z' class='g3'/%3E%0A%3Cpath d='M794 422.7h91.7v19.2H794V422.7Z' class='g3'/%3E%0A%3Cpath d='M794 448.4h91.7v19.2H794V448.4Z' class='g3'/%3E%0A%3Cpath d='M794 474h91.7v19.3H794V474Z' class='g3'/%3E%0A%3Cpath d='M794 519.9h91.7v19.2H794V519.9Z' class='g3'/%3E%0A%3C/svg%3E"
              />
            </div>
            <div className="text-container">
              <span
                className="t s1"
                style={{ left: 442, bottom: 640, letterSpacing: "-0.08px" }}
              >
                माता
              </span>
              <span className="t s0" style={{ left: 467, bottom: 640 }}>
                -
              </span>
              <span
                className="t s1"
                style={{ left: 471, bottom: 640, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 475, bottom: 640, letterSpacing: "-0.08px" }}
              >
                पता{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 500, bottom: 640, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 514, bottom: 640, letterSpacing: "-0.1px" }}
              >
                हAतार{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 562,
                  bottom: 640,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Parent{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 442, bottom: 620, letterSpacing: "-0.11px" }}
              >
                Signature{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 23, bottom: 519, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 27, bottom: 519, letterSpacing: "-0.1px" }}
              >
                दनांक{" "}
              </span>
              <span className="t s0" style={{ left: 61, bottom: 519 }}>
                /{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 23, bottom: 499, letterSpacing: "-0.12px" }}
              >
                Date{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 484, bottom: 519, letterSpacing: "-0.08px" }}
              >
                माता
              </span>
              <span className="t s0" style={{ left: 509, bottom: 519 }}>
                -
              </span>
              <span
                className="t s1"
                style={{ left: 514, bottom: 519, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 517, bottom: 519, letterSpacing: "-0.08px" }}
              >
                पता{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 542, bottom: 519, letterSpacing: "-0.08px" }}
              >
                का{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 560, bottom: 519, letterSpacing: "-0.11px" }}
              >
                नाम{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 585,
                  bottom: 519,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                / Parent{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 484, bottom: 499, letterSpacing: "-0.14px" }}
              >
                Name{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 769, bottom: 347, letterSpacing: "-0.08px" }}
              >
                धानाचया6{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 828, bottom: 347, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 769, bottom: 327, letterSpacing: "-0.1px" }}
              >
                हAतार{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 39, bottom: 1201, letterSpacing: "0.06px" }}
              >
                1.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 1201, letterSpacing: "-0.04px" }}
              >
                मW{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 72, bottom: 1201, letterSpacing: "-0.12px" }}
              >
                एदत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 99, bottom: 1201, letterSpacing: "-0.08px" }}
              >
                Xारा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 125, bottom: 1201, letterSpacing: "-0.09px" }}
              >
                घोषणा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 163, bottom: 1201, letterSpacing: "-0.1px" }}
              >
                करता{" "}
              </span>
              <span className="t s0" style={{ left: 197, bottom: 1201 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 205, bottom: 1201, letterSpacing: "-0.1px" }}
              >
                करती{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 239, bottom: 1201, letterSpacing: "-0.07px" }}
              >
                हूँ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 250, bottom: 1201, minWidth: "1em" }}
              >
                ि
              </span>
              <span className="t s1" style={{ left: 254, bottom: 1201 }}>
                क{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 269, bottom: 1201, letterSpacing: "0.04px" }}
              >
                मेरे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 288, bottom: 1201, letterSpacing: "-0.08px" }}
              >
                Xारा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 314, bottom: 1201, letterSpacing: "-0.07px" }}
              >
                दी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 329, bottom: 1201, letterSpacing: "-0.11px" }}
              >
                गई{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 348, bottom: 1201, letterSpacing: "-0.01px" }}
              >
                उपयु{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 372, bottom: 1201, letterSpacing: "0.73px" }}
              >
                6{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 389, bottom: 1201, letterSpacing: "-0.09px" }}
              >
                सूचना{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 424, bottom: 1201, letterSpacing: "-0.06px" }}
              >
                मेरी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 447, bottom: 1201, letterSpacing: "-0.1px" }}
              >
                जानकारी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 498, bottom: 1201, letterSpacing: "-0.17px" }}
              >
                मे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 511, bottom: 1201, letterSpacing: "-0.12px" }}
              >
                सZय{" "}
              </span>
              <span className="t s1" style={{ left: 539, bottom: 1201 }}>
                व{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 551, bottom: 1201, letterSpacing: "-0.09px" }}
              >
                सही{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 576, bottom: 1201, letterSpacing: "0.1px" }}
              >
                है{" "}
              </span>
              <span className="t s0" style={{ left: 584, bottom: 1201 }}>
                |{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 60,
                  bottom: 1181,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                i hereby declare that above information furnished by me is
                correct to the best of my knowledge &amp; belief.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 1161, letterSpacing: "-0.04px" }}
              >
                मW{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 72, bottom: 1161, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 76, bottom: 1161, letterSpacing: "-0.12px" }}
              >
                वधालय{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 120, bottom: 1161, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 134, bottom: 1161, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 138, bottom: 1161, letterSpacing: "-0.1px" }}
              >
                नयमो{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 171, bottom: 1161, letterSpacing: "-0.19px" }}
              >
                से{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 186, bottom: 1161, letterSpacing: "-0.12px" }}
              >
                ,तबK{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 229, bottom: 1161, letterSpacing: "-0.06px" }}
              >
                रहूँगा
              </span>
              <span className="t s0" style={{ left: 254, bottom: 1161 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 262, bottom: 1161, letterSpacing: "-0.06px" }}
              >
                रहूँगी{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 291,
                  bottom: 1161,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                i shall abide by the rule of the school.{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 1135,
                  letterSpacing: "-0.1px",
                  wordSpacing: "1.14px",
                }}
              >
                2. Below mentioned document no.{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 428,
                  bottom: 1135,
                  letterSpacing: "-0.09px",
                  wordSpacing: "-0.03px",
                }}
              >
                is/are not with me for now please accept it and i assure you to
                submit{" "}
              </span>
              <span
                className="t s0"
                style={{ left: 60, bottom: 1113, letterSpacing: "-0.09px" }}
              >
                it at earliest, if i don't submit, school will be free to take
                action as per forms.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 1091, letterSpacing: "-0.12px" }}
              >
                नीचे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 85, bottom: 1091, letterSpacing: "-0.11px" }}
              >
                उ[े&lt;खत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 133, bottom: 1091, letterSpacing: "-0.1px" }}
              >
                दAतावेज़{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 183, bottom: 1091, letterSpacing: "-0.09px" }}
              >
                संया{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 378, bottom: 1091, letterSpacing: "-0.1px" }}
              >
                अभी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 406, bottom: 1091, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 410, bottom: 1091, letterSpacing: "-0.1px" }}
              >
                वधाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 449, bottom: 1091, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 464, bottom: 1091, letterSpacing: "-0.1px" }}
              >
                पंजीकरण{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 516, bottom: 1091, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 531, bottom: 1091, letterSpacing: "-0.13px" }}
              >
                समय{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 562, bottom: 1091, letterSpacing: "-0.12px" }}
              >
                उपल(ध{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 608, bottom: 1091, letterSpacing: "-0.09px" }}
              >
                नही{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 632, bottom: 1091, letterSpacing: "0.1px" }}
              >
                है{" "}
              </span>
              <span
                className="t s1"
                style={{
                  left: 643,
                  bottom: 1091,
                  letterSpacing: "-1.2px",
                  wordSpacing: "1.96px",
                }}
              >
                कृ पया{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 678, bottom: 1091, letterSpacing: "-0.36px" }}
              >
                फाम6{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 705, bottom: 1091, letterSpacing: "-0.1px" }}
              >
                Aवीकार{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 749, bottom: 1091, letterSpacing: "0.06px" }}
              >
                करे{" "}
              </span>
              <span className="t s0" style={{ left: 766, bottom: 1091 }}>
                ,{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 774, bottom: 1091, letterSpacing: "-0.04px" }}
              >
                मW{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 787, bottom: 1091, letterSpacing: "-0.12px" }}
              >
                आश्वAत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 839, bottom: 1091, letterSpacing: "-0.1px" }}
              >
                करता{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 873, bottom: 1091, letterSpacing: "-0.07px" }}
              >
                हूँ{" "}
              </span>
              <span className="t s0" style={{ left: 880, bottom: 1091 }}>
                /{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 1069, letterSpacing: "-0.1px" }}
              >
                करती{" "}
              </span>
              <span
                className="t sa"
                style={{ left: 93, bottom: 1069, letterSpacing: "-0.05px" }}
              >
                हूँ.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 109, bottom: 1069, letterSpacing: "-0.1px" }}
              >
                ज^दी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 143, bottom: 1069, letterSpacing: "-0.07px" }}
              >
                ही{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 158, bottom: 1069, letterSpacing: "-0.13px" }}
              >
                समAत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 197, bottom: 1069, letterSpacing: "-0.1px" }}
              >
                दAतावेज़{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 247, bottom: 1069, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 251, bottom: 1069, letterSpacing: "-0.12px" }}
              >
                वधालय{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 295, bottom: 1069, letterSpacing: "-0.17px" }}
              >
                मे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 307, bottom: 1069, letterSpacing: "-0.09px" }}
              >
                जमा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 334, bottom: 1069, letterSpacing: "-0.09px" }}
              >
                करा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 358, bottom: 1069, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 362, bottom: 1069, letterSpacing: "-0.12px" }}
              >
                दये{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 383, bottom: 1069, letterSpacing: "-0.09px" }}
              >
                जाय&gt;गे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 417, bottom: 1069, letterSpacing: "-0.09px" }}
              >
                जमा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 444, bottom: 1069, letterSpacing: "-0.07px" }}
              >
                ना{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 460, bottom: 1069, letterSpacing: "-0.11px" }}
              >
                करने{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 489, bottom: 1069, letterSpacing: "-0.08px" }}
              >
                क_{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 508, bottom: 1069, letterSpacing: "-0.11px" }}
              >
                DAथ,त{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 546, bottom: 1069, letterSpacing: "-0.17px" }}
              >
                मे{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 558, bottom: 1069, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 562, bottom: 1069, letterSpacing: "-0.12px" }}
              >
                वधालय{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 606, bottom: 1069, letterSpacing: "-0.08px" }}
              >
                Xारा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 632, bottom: 1069, letterSpacing: "-0.09px" }}
              >
                &lt;लया{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 662, bottom: 1069, letterSpacing: "-0.08px" }}
              >
                गया{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 686, bottom: 1069, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 690, bottom: 1069, letterSpacing: "-0.1px" }}
              >
                नण6य{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 721, bottom: 1069, letterSpacing: "-0.1px" }}
              >
                मा'य{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 751, bottom: 1069, letterSpacing: "-0.08px" }}
              >
                होगा
              </span>
              <span className="t s0" style={{ left: 774, bottom: 1069 }}>
                |{" "}
              </span>
              <span
                className="t s2"
                style={{ left: 23, bottom: 965, letterSpacing: "-0.13px" }}
              >
                ENCLOSURES{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 128,
                  bottom: 965,
                  letterSpacing: "-0.1px",
                  wordSpacing: "-0.03px",
                }}
              >
                (All documents are mandatory at the time of admission){" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 945,
                  letterSpacing: "-0.09px",
                  wordSpacing: "1.54px",
                }}
              >
                1. Birth Certificate (Photocopy){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 247, bottom: 945, letterSpacing: "-0.12px" }}
              >
                ज'म{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 275, bottom: 945, letterSpacing: "-0.12px" }}
              >
                माण{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 309, bottom: 945, letterSpacing: "-0.11px" }}
              >
                प{" "}
              </span>
              <span className="t s0" style={{ left: 329, bottom: 945 }}>
                (
              </span>
              <span
                className="t s1"
                style={{ left: 334, bottom: 945, letterSpacing: "-0.1px" }}
              >
                छाया,त
              </span>
              <span className="t s0" style={{ left: 381, bottom: 945 }}>
                ){" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 919,
                  letterSpacing: "-0.12px",
                  wordSpacing: "1.57px",
                }}
              >
                2. Transfer Certificate (Original){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 252, bottom: 919, letterSpacing: "-0.1px" }}
              >
                Aथानांतरण{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 314, bottom: 919, letterSpacing: "-0.12px" }}
              >
                माण{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 348, bottom: 919, letterSpacing: "-0.11px" }}
              >
                प{" "}
              </span>
              <span className="t s0" style={{ left: 367, bottom: 919 }}>
                (
              </span>
              <span
                className="t s1"
                style={{ left: 372, bottom: 919, letterSpacing: "-0.11px" }}
              >
                मूल{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 395, bottom: 919, letterSpacing: "-0.11px" }}
              >
                ,त
              </span>
              <span className="t s0" style={{ left: 416, bottom: 919 }}>
                ){" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 893,
                  letterSpacing: "-0.13px",
                  wordSpacing: "0.78px",
                }}
              >
                3. Copy of Previous Year Report Card{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 293, bottom: 893, letterSpacing: "-0.12px" }}
              >
                अंक{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 319, bottom: 893, letterSpacing: "-0.11px" }}
              >
                प{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 339, bottom: 893, letterSpacing: "-0.1px" }}
              >
                अं,तम{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 374, bottom: 893, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 378, bottom: 893, letterSpacing: "-0.12px" }}
              >
                वालय{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 423, bottom: 893, letterSpacing: "-0.08px" }}
              >
                Xारा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 449, bottom: 893, letterSpacing: "-0.13px" }}
              >
                द`{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 868,
                  letterSpacing: "-0.1px",
                  wordSpacing: "0.75px",
                }}
              >
                4. Aadhar Card of the Student (Photocopy){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 325, bottom: 868, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 329, bottom: 868, letterSpacing: "-0.1px" }}
              >
                वधाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 368, bottom: 868, letterSpacing: "-0.08px" }}
              >
                का{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 386, bottom: 868, letterSpacing: "-0.12px" }}
              >
                आधार{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 425, bottom: 868, letterSpacing: "-0.38px" }}
              >
                काड6{" "}
              </span>
              <span className="t s0" style={{ left: 452, bottom: 868 }}>
                (
              </span>
              <span
                className="t s1"
                style={{ left: 457, bottom: 868, letterSpacing: "-0.1px" }}
              >
                छाया,त
              </span>
              <span className="t s0" style={{ left: 504, bottom: 868 }}>
                ){" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 842,
                  letterSpacing: "-0.13px",
                  wordSpacing: "0.78px",
                }}
              >
                5. Two Recent photograph of the Student{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 315, bottom: 842, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 318, bottom: 842, letterSpacing: "-0.1px" }}
              >
                वधाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 357, bottom: 842, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 372, bottom: 842, letterSpacing: "-0.07px" }}
              >
                दो{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 387, bottom: 842, letterSpacing: "-0.11px" }}
              >
                नवीनतम{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 437, bottom: 842, letterSpacing: "-0.1px" }}
              >
                ,च{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 816,
                  letterSpacing: "-0.1px",
                  wordSpacing: "1.14px",
                }}
              >
                6. Aadhar Card Parents (Photocopy){" "}
              </span>
              <span
                className="t s1"
                style={{ left: 285, bottom: 816, letterSpacing: "-0.12px" }}
              >
                आधार{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 323, bottom: 816, letterSpacing: "-0.38px" }}
              >
                काड6{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 350, bottom: 816, letterSpacing: "-0.08px" }}
              >
                क_{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 369, bottom: 816, letterSpacing: "-0.1px" }}
              >
                छाया,त{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 420, bottom: 816, letterSpacing: "-0.12px" }}
              >
                अ.भभावक{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 791,
                  letterSpacing: "-0.1px",
                  wordSpacing: "1.53px",
                }}
              >
                7. Photograph of Parent{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 203, bottom: 791, letterSpacing: "-0.12px" }}
              >
                अ.भभावक{" "}
              </span>
              <span className="t s0" style={{ left: 263, bottom: 791 }}>
                (
              </span>
              <span
                className="t s1"
                style={{ left: 268, bottom: 791, letterSpacing: "-0.08px" }}
              >
                माता
              </span>
              <span className="t s0" style={{ left: 293, bottom: 791 }}>
                -
              </span>
              <span
                className="t s1"
                style={{ left: 297, bottom: 791, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 301, bottom: 791, letterSpacing: "-0.08px" }}
              >
                पता
              </span>
              <span className="t s0" style={{ left: 321, bottom: 791 }}>
                )
              </span>
              <span
                className="t s1"
                style={{ left: 326, bottom: 791, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 341, bottom: 791, letterSpacing: "-0.1px" }}
              >
                ,च{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 765,
                  letterSpacing: "-0.1px",
                  wordSpacing: "0.44px",
                }}
              >
                8. Community Certificate : For Schedule Caste, Schedule Tribes,
                Backward Communities.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 60, bottom: 745, letterSpacing: "-0.1px" }}
              >
                जा,त{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 90, bottom: 745, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 94, bottom: 745, letterSpacing: "-0.09px" }}
              >
                वशेष{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 123, bottom: 745, letterSpacing: "-0.12px" }}
              >
                माण{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 157, bottom: 745, letterSpacing: "-0.11px" }}
              >
                प{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 177, bottom: 745, letterSpacing: "-0.08px" }}
              >
                क_{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 196, bottom: 745, letterSpacing: "-0.1px" }}
              >
                छाया,त{" "}
              </span>
              <span
                className="t s2"
                style={{ left: 23, bottom: 716, letterSpacing: "-0.11px" }}
              >
                Note:{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 695,
                  letterSpacing: "-0.1px",
                  wordSpacing: "0.44px",
                }}
              >
                1. Registration , Admission and any other fees are not
                refundable.{" "}
              </span>
              <span
                className="t s0"
                style={{
                  left: 39,
                  bottom: 670,
                  letterSpacing: "-0.09px",
                  wordSpacing: "0.2px",
                }}
              >
                2. If you opt for transportation then the transport charges
                payble for all the months from the month (you opted) till March.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 309, bottom: 479, letterSpacing: "-0.1px" }}
              >
                वेश{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 339, bottom: 479, letterSpacing: "-0.11px" }}
              >
                प{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 358, bottom: 479, letterSpacing: "-0.19px" }}
              >
                से{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 372, bottom: 479, letterSpacing: "-0.09px" }}
              >
                दा&lt;खला
              </span>
              <span className="t s0" style={{ left: 414, bottom: 479 }}>
                -
              </span>
              <span
                className="t s1"
                style={{ left: 419, bottom: 479, letterSpacing: "-0.11px" }}
              >
                खाOरज{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 23, bottom: 459, letterSpacing: "-0.1px" }}
              >
                रजAटर{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 69, bottom: 459, letterSpacing: "-0.13px" }}
              >
                म&gt;{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 82, bottom: 459, letterSpacing: "-0.09px" }}
              >
                सही{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 107, bottom: 459, letterSpacing: "-0.08px" }}
              >
                िविRयाँ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 155, bottom: 459, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 159, bottom: 459, letterSpacing: "-0.1px" }}
              >
                दनांक{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 23, bottom: 416, letterSpacing: "-3.53px" }}
              >
                के{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 38, bottom: 416, letterSpacing: "-0.09px" }}
              >
                पृa{" "}
              </span>
              <span
                className="t sa"
                style={{ left: 58, bottom: 416, letterSpacing: "-0.07px" }}
              >
                सं.{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 23, bottom: 373, letterSpacing: "-0.09px" }}
              >
                पर{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 41, bottom: 373, letterSpacing: "-0.11px" }}
              >
                कर{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 62, bottom: 373, letterSpacing: "-0.07px" }}
              >
                दी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 78, bottom: 373, letterSpacing: "-0.11px" }}
              >
                गई{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 96, bottom: 373, letterSpacing: "0.1px" }}
              >
                है{" "}
              </span>
              <span className="t s0" style={{ left: 104, bottom: 373 }}>
                |{" "}
              </span>
              <span className="t s0" style={{ left: 23, bottom: 327 }}>
                *
              </span>
              <span
                className="t s1"
                style={{ left: 29, bottom: 327, letterSpacing: "-0.1px" }}
              >
                यिद{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 53, bottom: 327, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 57, bottom: 327, letterSpacing: "-0.1px" }}
              >
                वाथ{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 96, bottom: 327, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 100, bottom: 327, letterSpacing: "-0.11px" }}
              >
                कसी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 129, bottom: 327, letterSpacing: "-0.12px" }}
              >
                अ'य{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 158, bottom: 327, letterSpacing: "-0.36px" }}
              >
                बोड6{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 183, bottom: 327, letterSpacing: "-0.19px" }}
              >
                से{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 197, bottom: 327, letterSpacing: "0.1px" }}
              >
                है{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 208, bottom: 327, letterSpacing: "-0.07px" }}
              >
                तो
              </span>
              <span className="t s0" style={{ left: 221, bottom: 327 }}>
                ,{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 229, bottom: 327, letterSpacing: "-0.1px" }}
              >
                Aथानांतरण{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 291, bottom: 327, letterSpacing: "-0.11px" }}
              >
                माणप{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 340, bottom: 327, letterSpacing: "-0.13px" }}
              >
                सम{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 372, bottom: 327, letterSpacing: "-0.09px" }}
              >
                ा,धकारी{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 426, bottom: 327, letterSpacing: "-0.08px" }}
              >
                Xारा{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 452, bottom: 327, letterSpacing: "-0.1px" }}
              >
                ,तहAताOरत{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 533, bottom: 327, minWidth: "1em" }}
              >
                ि
              </span>
              <span
                className="t s1"
                style={{ left: 537, bottom: 327, letterSpacing: "-0.1px" }}
              >
                कया{" "}
              </span>
              <span
                className="t s1"
                style={{ left: 564, bottom: 327, letterSpacing: "-0.09px" }}
              >
                जाएगा
              </span>
              <span className="t s0" style={{ left: 596, bottom: 327 }}>
                |{" "}
              </span>
              <span
                className="t s6"
                style={{
                  left: 382,
                  bottom: 186,
                  letterSpacing: "-0.19px",
                  wordSpacing: "-0.03px",
                }}
              >
                Counter Signature{" "}
              </span>
              <span
                className="t s2"
                style={{
                  left: 335,
                  bottom: 1231,
                  letterSpacing: "-0.13px",
                  wordSpacing: "-0.05px",
                }}
              >
                DECLARATION BY THE PARENTS{" "}
              </span>
            </div>
          </section>
        </div>
      </>
    </div>
  );
};

export default AdmissionForm
